import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useSelector, shallowEqual } from "react-redux";

const ACTIVE_URL = "api/workshops/active";
const EVENT_TYPES_URL = "api/workshops/event-types";


const EventContext = createContext();

export function useEventContext() {
  return useContext(EventContext);
}

export const EventConsumer = EventContext.Consumer;

export function EventContextProvider({ eventUIEvents, children }) {
  const [ACTIVE, SETACTIVE] = useState([]);
  // event_type rows (V097), for the list's Type column.
  const [EVENT_TYPES, SET_EVENT_TYPES] = useState([]);
  // The server's message (or a fallback) when they could not be loaded;
  // EventList shows it, and the Type column shows "—".
  const [EVENT_TYPES_ERROR, SET_EVENT_TYPES_ERROR] = useState("");
  // `setupAxios` is commented out in `src/index.js`, so `axios.defaults`
  // only gains the `x-auth-token` header as a side effect of
  // `getUserByToken()` inside the rehydrate saga (authRedux.js,
  // UserRequested) — which resolves *after* mount. `authToken` itself is
  // persisted and PersistGate blocks render until rehydrate finishes, so
  // it's already in the store at first mount even though axios isn't ready
  // yet. Gating on it and sending it explicitly (matching
  // useKioskDay.js/badgesCrud.js) is what stops a hard refresh from firing
  // this fetch unauthenticated and coming back 401.
  const authToken = useSelector((state) => state.auth.authToken, shallowEqual);

  // const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (!authToken) return;
    const INIT_HELPERS = async () => {
      try {
        let res_active = await axios(ACTIVE_URL, {
          headers: { "x-auth-token": authToken },
        });
        SETACTIVE(res_active.data.results);
      } catch (e) {
        console.error(e);
      }
      try {
        const res_types = await axios(EVENT_TYPES_URL, {
          headers: { "x-auth-token": authToken },
        });
        SET_EVENT_TYPES(res_types.data.results || []);
      } catch (e) {
        console.error(e);
        SET_EVENT_TYPES_ERROR(e.response?.data?.message || "Couldn't load event types");
      }
    };
    INIT_HELPERS();
  }, [authToken]);

  // const setRefetchHandler = (value) => {
  //   setRefetch(value);
  // };

  // const getRefetch = () => {
  //   return refetch;
  // };

  const eventContext = {
    newEventButtonClick: eventUIEvents.newEventButtonClick,
    openEditEventPage: eventUIEvents.openEditEventPage,
    openDeleteEventDialog: eventUIEvents.openDeleteEventDialog,
    openActivateEventDialog: eventUIEvents.openActivateEventDialog,
    openEventFullDialog: eventUIEvents.openEventFullDialog,
    openEventNotFullDialog: eventUIEvents.openEventNotFullDialog,
    openDuplicateEventPage: eventUIEvents.openDuplicateEventPage,
    openEmailAttendeesPage: eventUIEvents.openEmailAttendeesPage,
    refetch: eventUIEvents.refetch,
    setRefetch: eventUIEvents.setRefetch,
    TYPES: {
      ACTIVE,
      SETACTIVE,
      EVENT_TYPES,
      EVENT_TYPES_ERROR,
      SET_EVENT_TYPES_ERROR,
    },
  };

  return (
    <EventContext.Provider value={eventContext}>
      {children}
    </EventContext.Provider>
  );
}
